import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MatchCard } from './match-card';
import { brownlowMatchSelector } from '../../../store/js/modules/brownlow-tracker/match-by-match/selectors';

export const MatchCardVoteFetcher = ({
    matchData,
    totalVotes,
    seasonPid,
    seasonId,
    modifier,
    playerModalEnabled
}) => {
    const matchVotes = useSelector((state) =>
        brownlowMatchSelector(state, seasonPid, matchData.providerId)
    );

    return (
        <MatchCard
            voteData={matchVotes}
            matchData={matchData}
            totalVotes={totalVotes}
            seasonPid={seasonPid}
            seasonId={seasonId}
            modifier={modifier}
            playerModalEnabled={playerModalEnabled}
        />
    );
};

MatchCardVoteFetcher.propTypes = {
    matchData: PropTypes.object,
    totalVotes: PropTypes.object,
    seasonPid: PropTypes.string,
    seasonId: PropTypes.number,
    modifier: PropTypes.string,
    playerModalEnabled: PropTypes.bool
};
